import React, { useState, useRef, useEffect } from "react";
import useClickOutside from "../../hook/UseClickOutSide";

export interface SelectSatelliteType {
  onSelected: (satellite: string) => void;

  satellite: string;
}
function SelectSatellite({ onSelected, satellite }: SelectSatelliteType) {
  const options = [
    {
      id: 1,
      satelliteName: "ระบบ VIIRS",
      value: "VIIRS",
      hasChild: true,
      children: [
        { id: 1, name: "ดาวเทียม Suomi NPP", value: "Suomi NPP" },
        { id: 2, name: "ดาวเทียม NOAA-20", value: "NOAA-20" },
      ],
    },
    {
      id: 2,
      satelliteName: "ระบบ MODIS",
      value: "MODIS",
      hasChild: false,
      children: [],
    },
  ];
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [selectedValue, setSelectedValue] = useState<string>(
    options[0].children[0].name
  );

  const textMapping: any = {
    VIIRS: "ระบบ VIIRS",
    MODIS: "ระบบ MODIS",
    "Suomi NPP": "ดาวเทียม Suomi NPP",
    "NOAA-20": "ดาวเทียม NOAA-20",
  };

  const handleClickOpenItems = (value: boolean) => {
    setIsOpen(value);
  };

  const handleClickItems = (satelliteValue: string) => {
    setIsOpen(false);
    setSelectedValue(satelliteValue);
    onSelected(satelliteValue);
  };

  useClickOutside(dropdownRef, () => {
    setIsOpen(false);
  });

  useEffect(() => {
    if (satellite.trim() !== "") {
      setSelectedValue(satellite);
    } else {
      onSelected(options[0].children[0].value);
    }
  }, []);

  useEffect(() => {
    if (satellite.trim() !== "") {
      if (satellite === "VIIRS" || satellite === "MODIS") {
        let satelliteName = options.filter((e) => e.value === satellite);
        setSelectedValue(satelliteName[0].value);
      }
      if (satellite === "Suomi NPP" || satellite === "NOAA-20") {
        let satelliteName = options[0].children.filter(
          (e) => e.value === satellite
        );
        setSelectedValue(satelliteName[0].value);
      }
    } else {
      setSelectedValue(options[0].children[0].value);
    }
  }, [satellite]);

  return (
    <div className="relative" ref={dropdownRef}>
      <div
        className="flex self-stretch  pl-4 pr-2 h-10 bg-primary-contrast items-center rounded-xl border-[1px] border-gray-2"
        onClick={() => handleClickOpenItems(!isOpen)}
      >
        <p className="w-full text-sm text-text-primary font-light">
          {textMapping[selectedValue] || ""}
        </p>
        <div className={`${isOpen && "-rotate-180"}`}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_904_68250)">
              <path
                d="M6.70978 9.30996C7.09978 8.91996 7.72978 8.91996 8.11978 9.30996L11.9998 13.19L15.8798 9.30996C16.2698 8.91996 16.8998 8.91996 17.2898 9.30996C17.6798 9.69996 17.6798 10.33 17.2898 10.72L12.6998 15.31C12.3098 15.7 11.6798 15.7 11.2898 15.31L6.69978 10.72C6.31978 10.34 6.31978 9.69996 6.70978 9.30996Z"
                fill="#8E8E8E"
              />
            </g>
            <defs>
              <clipPath id="clip0_904_68250">
                <rect
                  width="24"
                  height="24"
                  fill="white"
                  transform="matrix(0 1 1 0 0 0)"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
      {isOpen && (
        <div className="w-full max-h-[300px]  overflow-y-auto z-10 absolute bg-primary-contrast p-2 border-[1px] mt-1 border-gray-2 rounded-2xl">
          {options.map((e: any) => (
            <div key={e.id} className="w-full cursor-pointer ">
              <p
                onClick={() => handleClickItems(e.value)}
                className="w-full text-sm py-1 pl-4 pr-2 text-text-primary font-light hover:bg-primary-light rounded-xl"
              >
                {e.satelliteName}
              </p>
              {e.hasChild && (
                <>
                  {e.children.map((child: any) => (
                    <div key={child.id} className={"w-full cursor-pointer "}>
                      <p
                        onClick={() => handleClickItems(child.value)}
                        className="w-full text-sm text-text-primary font-light py-1 pl-8 pr-2 hover:bg-primary-light rounded-xl"
                      >
                        {child.name}
                      </p>
                    </div>
                  ))}
                </>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default SelectSatellite;
